module.exports = __webpack_public_path__ + "img/bil.174cfc52.webp";